import { render, staticRenderFns } from "./JoaDemoList.vue?vue&type=template&id=88cc1a58&scoped=true&"
import script from "./JoaDemoList.vue?vue&type=script&lang=js&"
export * from "./JoaDemoList.vue?vue&type=script&lang=js&"
import style0 from "./JoaDemoList.vue?vue&type=style&index=0&id=88cc1a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc1a58",
  null
  
)

export default component.exports